import { Exchange } from '@/types/generated/common/types'

interface TickerChangeFields {
  priceChange24h?: string
  priceChangePercent24h?: string
}

export function resolvePriceChangePercent24h(
  _exchange: Exchange,
  ticker: TickerChangeFields | undefined
): string | undefined {
  if (!ticker) return undefined

  return ticker.priceChangePercent24h ?? ticker.priceChange24h
}
